<template>
  <AppDialog :is-open="isDialogOpened"
             ok-only
             size="xl"
             :persistent="false"
             :ok-text="$t('common.close')"
             @click:outside="closeDialog"
             @ok="closeDialog"
             @cancel="closeDialog"
  >
    <template #title>
      {{ $t('project.signed-documents.SignedDocumentsSignatoriesListDialog.title', { signatoriesCount: signatories.length }) }}
    </template>
    <template #body>
      <SignedDocumentsSignatoriesListModalItem v-for="signatory in signatories"
                                               :key="`signatory-${signatory.id}`"
                                               :signatory="signatory"
      />
    </template>
  </AppDialog>
</template>

<script>
import { mapActions } from 'vuex'

import AppDialog from '@/common/dialogs/AppDialog.vue'
import { dialogMixin } from '@/mixins/dialogMixin'

import SignedDocumentsSignatoriesListModalItem from './SignedDocumentsSignatoriesListModalItem.vue'

export default {
  name: 'SignedDocumentsSignatoriesListDialog',
  components: {
    AppDialog,
    SignedDocumentsSignatoriesListModalItem,
  },
  mixins: [dialogMixin],
  props: {
    signedDocument: {
      type: Object,
      required: true,
    },
    mnemo: {
      type: String,
      required: true,
    },
  },
  computed: {
    signatories () {
      const signatories = []
      if (this.signedDocument.mySignature) {
        signatories.push(this.signedDocument.mySignature)
      }
      if (this.signedDocument.otherSignatures.length > 0) {
        signatories.push(...this.signedDocument.otherSignatures)
      }
      return signatories
    },
  },
  mounted () {
    this.GET_GROUPS(this.mnemo)
  },
  methods: {
    ...mapActions('groups', ['GET_GROUPS']),
  },
}
</script>
